import React from "react";
import "./../styles/Contact.css";

const Contact = () => {
  return (
    <div className="lh-contact-page">
      <section className="lh-contact-hero">
        <p className="lh-contact-eyebrow">Kontakt &amp; Support</p>
        <h1>
          Dein direkter Kontakt zu <span>LearnHut</span>
        </h1>
        <p>
          Unser Team unterstützt dich bei organisatorischen Fragen rund um die
          Plattform. Die folgende Anfragefläche ist aktuell als visuelles Formular
          ausgelegt.
        </p>
      </section>

      <div className="lh-contact-layout">
        <div className="lh-contact-main">
          <section className="lh-contact-card">
            <div className="lh-contact-section-head">
              <h2>Direkte Anfrage</h2>
              <p>Design-only Darstellung, noch ohne Versand-Integration.</p>
            </div>

            <form className="lh-contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="lh-contact-grid">
                <label>
                  <span>Vollständiger Name</span>
                  <input type="text" placeholder="Julian Schmidt" />
                </label>
                <label>
                  <span>Akademische E-Mail</span>
                  <input type="email" placeholder="j.schmidt@university.edu" />
                </label>
              </div>

              <label>
                <span>Fachbereich / Anliegen</span>
                <select defaultValue="allgemein">
                  <option value="allgemein">Allgemeine Anfragen</option>
                  <option value="zulassung">Zulassungsstelle</option>
                  <option value="it">IT-Infrastruktur</option>
                  <option value="forschung">Forschungsförderung</option>
                </select>
              </label>

              <label>
                <span>Deine Nachricht</span>
                <textarea
                  rows="5"
                  placeholder="Beschreibe dein Anliegen so detailliert wie möglich..."
                />
              </label>

              <button className="lh-contact-submit" type="button">
                Nachricht senden
              </button>
            </form>
          </section>

          <section className="lh-contact-directory">
            <h2>Fachbereichs-Verzeichnis</h2>
            <div className="lh-contact-directory-grid">
              <article>
                <h3>Zulassung &amp; Immatrikulation</h3>
                <p>admissions@learnhut.edu</p>
              </article>
              <article>
                <h3>Studierendensekretariat</h3>
                <p>registrar@learnhut.edu</p>
              </article>
              <article>
                <h3>IT-Service Desk</h3>
                <p>support@learnhut.edu</p>
              </article>
              <article>
                <h3>Pressestelle</h3>
                <p>press@learnhut.edu</p>
              </article>
            </div>
          </section>
        </div>

        <aside className="lh-contact-aside">
          <section className="lh-contact-aside-card">
            <h3>Campus Anschrift</h3>
            <p>LearnHut University</p>
            <p>Akademieallee 12-14</p>
            <p>10117 Berlin, Deutschland</p>
            <div className="lh-contact-aside-sep" />
            <p>+49 (0) 30 555 392-0</p>
            <p>info@learnhut.edu</p>
          </section>

          <section className="lh-contact-aside-highlight">
            <h3>Datenschutz &amp; Integrität</h3>
            <p>
              Anfragen werden nach DSGVO-konformen Standards behandelt und nur an
              zuständige Stellen weitergegeben.
            </p>
          </section>
        </aside>
      </div>
    </div>
  );
};

export default Contact;
